import { API_BASE_URL } from '@/environment'
import { customFetch } from '@/service/v3/apiV3Utils'
import { toQueryParams } from '@/helpers/api/toQueryParams'
import type {
  GetUserPlaytimeParams,
  GetUserProductsParams,
  ListCompanyUsersParams,
} from '@/service/v3/endpoints/usersParams'
import type { User } from '@/types'
import type { V3PaginatedResponse } from '@/types/V3UtilityTypes'
import { queryParams } from '@attensi/utils'

export const getUserProducts = async (params: GetUserProductsParams) => {
  const userQueryParams = {
    include: params.include,
    'page[number]': params.pageNumber,
    'page[size]': params.pageSize,
    'filter[product_type]': params.filterProductType,
    'filter[no_score]': params.filterNoScore,
    'filter[term]': params.filterTerm,
    'filter[certified]': params.filterCertified,
    'filter[sub_product]': params.filterSubProduct,
    'filter[published]': params.filterPublished,
    'fields[products]': params.productsFields,
    'fields[parent]': params.parentFields,
  }
  const url = queryParams(
    `${API_BASE_URL}/api/v3/admin/users/${params.userId}/products`,
    userQueryParams
  )

  return await customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}

export const resetOnboarding = async (userId: number) => {
  const url = `${API_BASE_URL}/api/v3/admin/users/${userId}/onboarding`
  return customFetch(url, {
    method: 'DELETE',
  })
}

export const resetPassword = async ({
  userId,
  companyNameKey,
}: {
  userId: string
  companyNameKey: string
}) => {
  const url = `${API_BASE_URL}/api/v3/admin/companies/${companyNameKey}/users/${userId}/reset_password`
  return customFetch(url, {
    method: 'DELETE',
  })
}

export const getUserProductPlaytime = async (params: GetUserPlaytimeParams) => {
  const url = `${API_BASE_URL}/api/v3/admin/companies/${params.companyNameKey}/users/${params.userId}/products/${params.productId}/playtime`

  return await customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}

export const deleteUserProductPlaytime = async (
  params: GetUserPlaytimeParams
) => {
  const url = `${API_BASE_URL}/api/v3/admin/companies/${params.companyNameKey}/users/${params.userId}/products/${params.productId}/playtime`

  return await customFetch(url, {
    method: 'DELETE',
  })
}

export const listCompanyUsers = async (
  params: ListCompanyUsersParams
): V3PaginatedResponse<User> => {
  const companyUsersQueryParams = {
    ...toQueryParams(
      {
        term: params.filterTerm,
        departmentId: params.filterDepartmentId,
        positionId: params.filterPositionId,
        withSubdepartments: params.filterWithSubdepartments,
        notInGroupId: params.filterNotInGroupId,
      },
      'filter'
    ),
    ...toQueryParams(
      {
        number: params.pageNumber,
        size: params.pageSize,
      },
      'page'
    ),
    sort: params.sort,
  }

  const url = queryParams(
    `${API_BASE_URL}/api/v3/admin/companies/${params.companyNameKey}/users`,
    companyUsersQueryParams
  )

  return await customFetch(url, {
    method: 'GET',
  }).then((response) => response.json())
}
